import { render, staticRenderFns } from "./WhatsappV2BotStateChanged.vue?vue&type=template&id=67aa7cc8&scoped=true"
import script from "./WhatsappV2BotStateChanged.vue?vue&type=script&lang=js"
export * from "./WhatsappV2BotStateChanged.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67aa7cc8",
  null
  
)

export default component.exports